'use client'

import {
	type Dispatch,
	type SetStateAction,
	createContext,
	useMemo,
	useState,
} from 'react'

interface ChatDialogContext {
	isDialogOpen: boolean
	setIsDialogOpen: Dispatch<SetStateAction<boolean>>
}

export const ChatbotDialogContext = createContext<
	ChatDialogContext | undefined
>(undefined)

interface ChatbotDialogProviderProps {
	readonly isOpen?: boolean
	readonly children: React.ReactNode
}

export function ChatbotDialogProvider({
	isOpen = false,
	children,
}: ChatbotDialogProviderProps): React.ReactNode {
	const [isDialogOpen, setIsDialogOpen] = useState(isOpen)

	const value = useMemo(
		() => ({
			isDialogOpen,
			setIsDialogOpen,
		}),
		[isDialogOpen, setIsDialogOpen]
	)

	return (
		<ChatbotDialogContext.Provider value={value}>
			{children}
		</ChatbotDialogContext.Provider>
	)
}
